import React from "react";
import "./navsociallink.css";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaInstagram,
} from "react-icons/fa";

const NavSocialLink = () => {
  return (
    <div className="nav-social-link flex-container">
      <div className="navsociallink container">
        <div className="left-sociallinks">
          <i className="fa-solid fa-phone"></i>
          <a href="tel:+923078611011">+923078611011</a>
          <i className="fa-solid fa-envelope email-icon"></i>
          <a href="mailto: info@mehfoozmustaqbil.org">
            info@mehfoozmustaqbil.org
          </a>
        </div>

        <div className="right-sociallinks" >
          <a
            target="_blank" rel="noreferrer" 
            href="https://m.facebook.com/mehfoozmustaqbilfoundation"
          >
            <FaFacebookF />
          </a>
          <a
            target="_blank" rel="noreferrer" 
            href="https://www.instagram.com/mehfoozmustaqbilfoundation/"
          >
            <FaInstagram />
          </a>
          <a
            target="_blank" rel="noreferrer" 
            href="https://www.linkedin.com/company/mehfoozmustaqbilfoundation/"
          >
            <FaLinkedinIn />
          </a>
        </div>
      </div>

      <marquee className="moving-text" behavior="scroll" scrollamount="10" direction="left"> 🚨 We are looking for donors for our ongoing cases of student fees, please connect with us on social media to know more. </marquee>
    </div>
  );
};

export default NavSocialLink;
